module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_02.f0c51160.png";